import z from 'zod';

const envSchema = z.object({
  // account management
  VITE_ACCOUNT_MANAGEMENT_API_URL: z.string(),

  // app
  VITE_APP_NAME: z.string().default('app'),

  VITE_APP_VERSION: z.string().default('development'),

  // campaign management (revalida)
  VITE_CAMPAIGN_MANAGEMENT_API_URL: z.string(),

  // capital markets
  VITE_CAPITAL_MARKETS_API_URL: z.string(),

  // contract formalization
  VITE_CONTRACT_FORMALIZATION_URL: z.string(),

  // core api
  VITE_CORE_API_URL: z.string(),

  // customer register api
  VITE_CUSTOMER_REGISTER_API_URL: z.string(),

  // device orchestrator gateway
  VITE_DEVICE_ORCHESTRATOR_GATEWAY_API_URL: z.string(),

  // financing flow
  VITE_FINANCING_FLOW_API_URL: z.string(),

  // financing platform
  VITE_FINANCING_PLATFORM_API_URL: z.string(),

  // formalization
  VITE_FORMALIZATION_API_URL: z.string(),

  // installation monorepo
  VITE_INSTALLATION_MONOREPO: z.string(),

  // installation risk
  VITE_INSTALLATION_RISK_API_URL: z.string(),

  // keycloak
  VITE_KEYCLOAK_API_URL: z.string(),

  VITE_KEYCLOAK_CLIENT_ID: z.string(),

  VITE_KEYCLOAK_REALM: z.string(),

  // partner blocklist
  VITE_PARTNER_BLOCKLIST_API_URL: z.string(),

  // person api
  VITE_PERSON_API_URL: z.string(),

  // receipt model
  VITE_RECEIPT_MODEL_URL: z.string(),

  // rule engine
  VITE_RULE_ENGINE_API_URL: z.string().optional(),

  // sensitive credentials
  VITE_SENSITIVE_CREDENTIALS_API_URL: z.string(),

  // service register api
  VITE_SERVICE_REGISTER_API_URL: z.string(),
});

const env = envSchema.parse(import.meta.env);

export default env;

declare global {
  export interface ImportMetaEnv extends z.infer<typeof envSchema> { }
}
